'use strict'

var $ = require('jquery');
var Carousel = require('./Carousel.js');

function init(config) {
	var config = $.extend({}, {
		component: 'timeline',
		item: 'timelineSlide',
		triggerBar: 'timelineBar',
		trigger: 'timelineBar__year'
	}, config);
	if (config.itemActiveClass === undefined) {
		config.itemActiveClass = config.item + '--active';
	}
	if (config.triggerActiveClass === undefined) {
		config.triggerActiveClass = config.trigger + '--active';
	}

	var $component = $('.' + config.component);

	// Skip if component absent or is browser with limited support (checked with no-flexbox)
	if ($component.length === 0 || $('html').hasClass('no-flexbox')) {
		return;
	}

	function setActiveCollageImage() {
		var activeSlideCollageImages = this.$activeSlide.find($('.timelineSlide__image--topLayer'));
		var zIndexs = [];

		activeSlideCollageImages.each(function() {
			var zIndex = $(this).css('z-index') == 'auto' ? 0 : parseInt($(this).css('z-index'));
			zIndexs.push(zIndex);
		});

		var highestZIndex = Math.max.apply(null, zIndexs);
		var $previouslyHoveredImage_bottomLayer = '';
		
		this.$activeSlide.on('mouseenter', '.timelineSlide__image--topLayer', function() {
			if ($(this).hasClass('timelineSlide__image--active')) {
				return;
			}

			/* 	Move the "bottom layer" image to the same z-index as its "top layer"
				but only after the "top layer" has transitioned to opacity: 1,
				otherwise the transition won't be visible */
			if ($previouslyHoveredImage_bottomLayer.length) {
				$previouslyHoveredImage_bottomLayer.css('z-index', highestZIndex);
			}

			$('.timelineSlide__image--topLayer').removeClass('timelineSlide__image--active');
			$(this).addClass('timelineSlide__image--active');

			$(this).css('z-index', highestZIndex + 1);
			highestZIndex++;

			$previouslyHoveredImage_bottomLayer = $(this).prev();
		});
	}

	function changeBackground(index) {
		$('[class*="timeline__background"]').attr('data-active', 'false');
		this.$carousel.find($('[class*="timeline__background"][data-slide="' + index + '"]')).attr('data-active', 'true');
	}
	
	// Initialize carousel functionality
	var timeline = new Carousel({
		component: 'timeline',
		trigger: ['timelineBar__year'],
		item: 'timelineSlide',
		itemHeightObject: 'timelineSlide__inner',
		itemWrapper: 'slides',
		activeClassModifier: 'active',
		firstLastInViewRecipients: ['timelineBar__innerShade'],
		centerElements: ['timelineBar__year'],
		newHeightScale: 0.7,
		doAutoAdvance: false,
		doPopup: true,
		doPreviousClass: true,
		doReverseAnimation: true,
		doVariableHeight: false,
		doFixedHeight: true,
		callbacks: {
			setActiveCollageImage: setActiveCollageImage,
			changeBackground: changeBackground
		}
	});
	timeline.activate();
};


var Timeline = {
	init: init
};

module.exports = Timeline;
